<template>
  <v-container ma-0 pa-0>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{ user.firstName }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn text @click="doLogout">
            Sair
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list dense>
      <v-subheader>FILIAIS</v-subheader>
      <v-list-item-group color="primary" v-model="listSelection" mandatory>
        <v-list-item
          v-for="(item, index) in user.managerUnits"
          :key="index"
          :value="item.id"
          link
          @change="setCurrentUnit(item.unit)"
        >
          <v-list-item-action>
            <v-icon>mdi-map-marker-radius</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.unit.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Units",
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    //idList: 1,
  }),
  methods: {
    ...mapState("units", ["currentUnit"]),
    ...mapActions("auth", ["ActionSignOut"]),
    ...mapActions("units", ["ActionSetCurrentUnit", "ActionFindClassList"]),
    async doLogout() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (err) {
        console.log(err);
      }
    },
    async setCurrentUnit(unit) {
      await this.ActionSetCurrentUnit(unit);
      await this.ActionFindClassList(this.value);
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    listSelection: {
      get: function() {
        if (this.value.id == null || this.user.managerUnits == null) {
          if (this.user.managerUnits != null) {
            this.ActionSetCurrentUnit(this.user.managerUnits[0].unit);
          }
          return;
        }

        return this.user.managerUnits.indexOf(
          this.user.managerUnits.find(item => item.unitId === this.value.id)
        );
      },
      set: function() {
        //newVal = 38;
        //console.log(this.user.managerUnits.indexOf(newVal));
        //this.$emit("input", this.user.managerUnits.indexOf(newVal));
      }
    }
  }
};
</script>
